import { useTranslation } from 'react-i18next'
import React from 'react'

import AssetsControlBar from './AssetsControlBar'
import AssetsCounterBar from './AssetsCounterBar'

const PageHeader = () => {
  const { t } = useTranslation(['common', 'listAsset'])

  return (
    <>
      <AssetsControlBar />
      <AssetsCounterBar />
    </>
  )
}

export default PageHeader
